import Vue from "vue";

export const EngineerEventBus = new Vue();
